<template>
  <div id="app">
    <navBar/>
    <div class="zhongbox">
      <router-view />
    </div>
    <footer-bar />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import FooterBar from '@/components/FootBar.vue'
export default {
  name: "App",
  components: {
    NavBar,FooterBar
  },
    
};
</script>
<style lang="scss" >

.zhongbox{
  height: calc(100vh - 249px);
  overflow: hidden;
}
</style>
